import {
  GridFilterInputValue,
  type GridFilterOperator,
} from "@mui/x-data-grid-premium";
import { TextFilterModeEnum } from "@exonn/js-sdk";
import { Trans } from "react-i18next";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";
import { css } from "@emotion/react";

export const getDataGridTextFilterOperators = ({
  caseSensitive = false,
}: {
  caseSensitive?: boolean;
} = {}): GridFilterOperator[] => {
  return [
    {
      value: TextFilterModeEnum.Contains,
      getApplyFilterFn: (filterItem) => {
        return (value) => {
          if (!filterItem.value) {
            return true;
          }
          const lowerCasedFilterValue = (filterItem.value + "")[
            caseSensitive ? "toString" : "toLowerCase"
          ]();

          const lowerCasedValue = (value + "")[
            caseSensitive ? "toString" : "toLowerCase"
          ]();

          return lowerCasedValue.indexOf(lowerCasedFilterValue) !== -1;
        };
      },
      InputComponent: GridFilterInputValue,
      // @ts-ignore
      label: (
        <Trans
          i18nKey="header-filters.operator.contains"
          ns={TranslationNamespaceEnum.DataGridComponent}
        />
      ),
      // @ts-ignore
      headerLabel: (
        <div css={labelContainer}>
          <div css={iconContainer}>
            <i className={"icon-15-contains"} />
          </div>
          <Trans
            i18nKey="header-filters.operator.contains"
            ns={TranslationNamespaceEnum.DataGridComponent}
          />
        </div>
      ),
    },
    {
      value: TextFilterModeEnum.StartsWith,
      getApplyFilterFn: (filterItem) => {
        return (value) => {
          if (!filterItem.value) {
            return true;
          }

          const lowerCasedFilterValue = (filterItem.value + "")[
            caseSensitive ? "toString" : "toLowerCase"
          ]();

          const lowerCasedValue = (value + "")[
            caseSensitive ? "toString" : "toLowerCase"
          ]();

          return lowerCasedValue.startsWith(lowerCasedFilterValue);
        };
      },
      InputComponent: GridFilterInputValue,
      // @ts-ignore
      label: (
        <Trans
          i18nKey="header-filters.operator.starts_with"
          ns={TranslationNamespaceEnum.DataGridComponent}
        />
      ),
      // @ts-ignore
      headerLabel: (
        <div css={labelContainer}>
          <div css={iconContainer}>
            <i className={"icon-15-strt_wth"} />
          </div>
          <Trans
            i18nKey="header-filters.operator.starts_with"
            ns={TranslationNamespaceEnum.DataGridComponent}
          />
        </div>
      ),
    },
    {
      value: TextFilterModeEnum.EndsWith,
      getApplyFilterFn: (filterItem) => {
        return (value) => {
          if (!filterItem.value) {
            return true;
          }
          const lowerCasedFilterValue = (filterItem.value + "")[
            caseSensitive ? "toString" : "toLowerCase"
          ]();

          const lowerCasedValue = (value + "")[
            caseSensitive ? "toString" : "toLowerCase"
          ]();
          return lowerCasedValue.endsWith(lowerCasedFilterValue);
        };
      },
      InputComponent: GridFilterInputValue,
      // @ts-ignore
      label: (
        <Trans
          i18nKey="header-filters.operator.ends_with"
          ns={TranslationNamespaceEnum.DataGridComponent}
        />
      ),
      // @ts-ignore
      headerLabel: (
        <div css={labelContainer}>
          <div css={iconContainer}>
            <i className={"icon-15-end_wth"} />
          </div>
          <Trans
            i18nKey="header-filters.operator.ends_with"
            ns={TranslationNamespaceEnum.DataGridComponent}
          />
        </div>
      ),
    },
    {
      value: TextFilterModeEnum.Exact,
      getApplyFilterFn: (filterItem, column) => {
        return (value) => {
          if (!filterItem.value) {
            return true;
          }
          const lowerCasedFilterValue = (filterItem.value + "")[
            caseSensitive ? "toString" : "toLowerCase"
          ]();

          const lowerCasedValue = (value + "")[
            caseSensitive ? "toString" : "toLowerCase"
          ]();
          return lowerCasedValue === lowerCasedFilterValue;
        };
      },
      InputComponent: GridFilterInputValue,
      // @ts-ignore
      label: (
        <Trans
          i18nKey="header-filters.operator.exact"
          ns={TranslationNamespaceEnum.DataGridComponent}
        />
      ),
      // @ts-ignore
      headerLabel: (
        <div css={labelContainer}>
          <div css={iconContainer}>
            <i className={"icon-15-exact"} />
          </div>
          <Trans
            i18nKey="header-filters.operator.exact"
            ns={TranslationNamespaceEnum.DataGridComponent}
          />
        </div>
      ),
    },
  ];
};

const labelContainer = css`
  display: flex;
  align-items: center;
`;

const iconContainer = css`
  display: flex;
  align-items: center;
  margin-right: 5px;
  font-size: 15px;
`;
